import React from "react";
import { TESTIMONIALS } from "../../data/content";
export function Testimonials() {
  return <section className="bg-neutral-950 py-16 px-4 border-t border-neutral-900" data-id="element-223" data-mp="3hh66ruyitn01">
      <div className="max-w-6xl mx-auto" data-id="element-224" data-mp="3mgsj826iyz7s">
        <h2 className="font-display text-3xl sm:text-5xl text-white text-center uppercase mb-10" data-id="element-225" data-mp="3mfr5tr21e0mw">
          ❤️ Más emprendedores que <span className="text-[#e10600]" data-id="element-226" data-mp="3r8tsdf8ec9tl">ya empezaron</span>
        </h2>

        <div className="grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-227" data-mp="68l3pt0uo5">
          {TESTIMONIALS.map(t => <figure key={t.name} className="bg-black border border-neutral-800 rounded-2xl p-6" data-id="element-228" data-mp="421fcnqi809b">
              <div className="flex items-center gap-3 mb-3" data-id="element-229" data-mp="91meay5oc8m1">
                <div className="w-11 h-11 rounded-full bg-[#e10600] flex items-center justify-center font-display text-white" data-id="element-230" data-mp="e0z2pnc71nqq">
                  {t.initials}
                </div>
                <div data-id="element-231" data-mp="2avdenx68huq6">
                  <div className="text-yellow-400 text-sm leading-none" data-id="element-232" data-mp="2fsc8sfpwe1od">⭐⭐⭐⭐⭐</div>
                  <div className="text-white font-semibold text-sm mt-1" data-id="element-233" data-mp="2fu6sxrtchpre">{t.name}</div>
                </div>
              </div>
              <div className="text-xs text-neutral-500 mb-3" data-id="element-234" data-mp="1nu2msgys4ttb">
                📍 {t.location} | {t.product}
              </div>
              <blockquote className="text-neutral-300 text-sm leading-relaxed" data-id="element-235" data-mp="1ivrewbs1otdq">"{t.quote}"</blockquote>
            </figure>)}
        </div>
      </div>
    </section>;
}